"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSentryErrorReporter = exports.thresholdSame = exports.afterThreshold = exports.post = exports.generateJsonRPCObject = void 0;
const Sentry = __importStar(require("@sentry/browser"));
const config_json_1 = __importDefault(require("./config.json"));
const logger_1 = require("./logger");
const generateJsonRPCObject = (method, parameters) => ({
    jsonrpc: '2.0',
    method,
    id: 10,
    params: parameters,
});
exports.generateJsonRPCObject = generateJsonRPCObject;
const post = (url, body) => __awaiter(void 0, void 0, void 0, function* () {
    const request = yield fetch(url, {
        body: JSON.stringify(body),
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
    });
    if (request.status >= 400) {
        const err = yield request.text();
        return {
            ok: false,
            response: err,
        };
    }
    else {
        const result = yield request.json();
        return {
            ok: true,
            response: result,
        };
    }
});
exports.post = post;
function afterThreshold(promises, thresholdCount = promises.length, callback) {
    return new Promise((resolve, reject) => {
        const results = new Array(promises.length).fill(undefined);
        const errors = new Array(promises.length).fill(undefined);
        let done = false;
        let count = 0;
        promises.forEach((promise, i) => {
            promise
                .then((response) => {
                results[i] = response;
            })
                .catch((error) => {
                errors[i] = error;
            })
                .finally(() => {
                if (done)
                    return;
                count += 1;
                if (count >= thresholdCount) {
                    callback(results.slice(0))
                        .then((data) => {
                        done = true;
                        return resolve(data);
                    })
                        .catch((err) => {
                        const logger = (0, logger_1.getLogger)('afterThreshold');
                        logger.info('error during deriving private key', err);
                        logger.error(`${err.message}: ${err.name}: ${err.stack}`);
                    })
                        .finally(() => {
                        if (count === promises.length && !done) {
                            return reject(`Could not finish after all resolution: errors: ${JSON.stringify(errors)}`);
                        }
                    });
                }
            });
        });
    });
}
exports.afterThreshold = afterThreshold;
const thresholdSame = (arr, t) => {
    const hashMap = {};
    for (let i = 0; i < arr.length; i += 1) {
        const str = JSON.stringify(arr[i]);
        hashMap[str] = hashMap[str] ? hashMap[str] + 1 : 1;
        if (hashMap[str] === t) {
            return arr[i];
        }
    }
    return undefined;
};
exports.thresholdSame = thresholdSame;
const getSentryErrorReporter = () => {
    Sentry.init({
        dsn: config_json_1.default.SENTRY_DSN,
        maxBreadcrumbs: 1,
        debug: false,
    });
    return (msg) => {
        Sentry.captureMessage(msg);
    };
};
exports.getSentryErrorReporter = getSentryErrorReporter;
